(() => {
  const relocateControls = () => {
    document.querySelectorAll('.product-card-wrapper').forEach((card) => {
      const group = card.querySelector('.shcmp-add-group');
      if (group && group.parentElement !== card) card.appendChild(group);

      const buttons = [...card.querySelectorAll('.shcmp-add[data-shcmp-handle]')];
      if (!buttons.length) return;

      if (!group && buttons[0].parentElement !== card) card.appendChild(buttons[0]);

      buttons.forEach((button) => {
        if (button.dataset.shcmpCardControlBound === 'true') return;
        button.dataset.shcmpCardControlBound = 'true';

        button.addEventListener('pointerdown', (event) => event.stopPropagation());
        button.addEventListener('mousedown', (event) => event.stopPropagation());
        button.addEventListener('touchstart', (event) => event.stopPropagation(), { passive: true });
        button.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
        });
      });
    });
  };

  const boot = () => {
    relocateControls();

    let queued = false;
    const observer = new MutationObserver(() => {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(() => {
        queued = false;
        relocateControls();
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', relocateControls);
})();
